// Port of api/fuel/app/classes/model/group.php
import Model from 'offline/stream/model/base'
import F from 'offline/filter/constants'

export default Model.extend({
	table: 'groups',
	prefix: 'group',
	key: 'group_id',
	fields: {
		group_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		group_type: Model.SCHEMA_NUMBER,
		group_membership: Model.SCHEMA_NUMBER,
		group_avatar: Model.SCHEMA_TEXT,
		group_name: Model.SCHEMA_TEXT,
		group_slug: Model.SCHEMA_TEXT,
		group_oldslug: Model.SCHEMA_TEXT,
		group_date_created: Model.SCHEMA_DATE_CREATE,
		group_date_play_first: Model.SCHEMA_DATE,
		group_count_users: Model.SCHEMA_NUMBER,
		group_count_sync: Model.SCHEMA_NUMBER,
		group_count_collection: Model.SCHEMA_NUMBER,
		group_count_collection_games: Model.SCHEMA_NUMBER,
		group_count_collection_expansions: Model.SCHEMA_NUMBER,
		group_count_ratings: Model.SCHEMA_NUMBER,
		group_count_plays: Model.SCHEMA_NUMBER,
		group_count_plays_games: Model.SCHEMA_NUMBER,
		group_count_lists: Model.SCHEMA_NUMBER,
		group_count_daily: Model.SCHEMA_NUMBER,
		group_count_daily_self: Model.SCHEMA_NUMBER,
		group_count_daily_perk: Model.SCHEMA_NUMBER,
		group_count_weekly: Model.SCHEMA_NUMBER,
		group_data_queue: Model.SCHEMA_NUMBER,
		group_data_version: Model.SCHEMA_NUMBER
	},
	methods: {
		get_type_constant: function() { return F.OWNER_GROUP },
		get_data_version: function() { return this._data.group_data_version || 0 },
		get_threshold: function() {
			var count = this.get_count_users() || 0
			if (count <= 1) return 1
			if (count <= 4) return 2
			if (count <= 6) return 3
			if (count <= 15) return 4
			if (count <= 25) return 5
			if (count <= 30) return 6
			if (count <= 40) return 7
			if (count <= 50) return 8
			if (count <= 60) return 9
			return 10
		},
		to_array: function() {
			return {
				id: this.get_id(),
				membership: this.get_membership() || 0,
				name: this.get_name(),
				slug: this.get_slug(),
				avatar: this.get_avatar(),
				threshold: this.get_threshold(),
				owner: this.get_user_id() || 0,
				date: { sync: false, firstPlay: this.get_date_play_first() || 0 },
				queueSync: this.get_data_queue() || 0,
				count: {
					collection: this.get_count_collection() || 0,
					ratings: this.get_count_ratings() || 0,
					users: this.get_count_users() || 0,
					plays: this.get_count_plays() || 0,
					lists: this.get_count_lists() || 0,
					sync: 0,
					daily: this.get_count_daily() || 0,
					weekly: this.get_count_weekly() || 0
				},
				queued: 0,
				subdomain: false,
				externaldomain: false,
				boosted: false,
				requireSync: false
			}
		}
	}
})
